var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDevis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.3 25.213 1.944 1.944a.69.69 0 0 0 .972 0l3.889-3.889a.688.688 0 0 0-.972-.972L23.73 25.7l-1.458-1.459a.688.688 0 0 0-.972.973",
    fill: "#E5A033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 14.438h13.75a.688.688 0 0 0 0-1.376H6.875a.688.688 0 0 0 0 1.376m0 4.125H16.5a.688.688 0 0 0 0-1.375H6.875a.688.688 0 0 0 0 1.375m0 4.125h8.25a.688.688 0 0 0 0-1.375h-8.25a.688.688 0 0 0 0 1.375m0 4.125h8.25a.688.688 0 0 0 0-1.375h-8.25a.688.688 0 0 0 0 1.375",
    fill: "#13123A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 32.313H4.125a3.44 3.44 0 0 1-3.437-3.438V9.389a3.44 3.44 0 0 1 1.006-2.43l5.264-5.265A3.44 3.44 0 0 1 9.39.688h13.986a3.44 3.44 0 0 1 3.438 3.437v13.348a7.57 7.57 0 0 1 5.5 7.277 7.566 7.566 0 0 1-7.563 7.563m.688-15.095V4.125a2.06 2.06 0 0 0-2.063-2.062H9.389q-.23 0-.451.05V5.5A3.44 3.44 0 0 1 5.5 8.938H2.113q-.05.221-.05.451v19.486a2.06 2.06 0 0 0 2.062 2.063h16.278a7.56 7.56 0 0 1-3.215-6.188 7.566 7.566 0 0 1 8.25-7.532m-.688 1.345a6.19 6.19 0 0 1 6.188 6.187 6.19 6.19 0 0 1-6.188 6.188 6.19 6.19 0 0 1-6.187-6.188 6.19 6.19 0 0 1 6.187-6.187M7.563 3.034 3.035 7.563H5.5A2.06 2.06 0 0 0 7.563 5.5z",
    fill: "#13123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevis);
export default __webpack_public_path__ + "static/media/ic_devis.190646d711ed5cacd6de4f5f5281de32.svg";
export { ForwardRef as ReactComponent };